export const VIDEO_EVENT = {
  PLAY: 'play',
  PAUSE: 'pause'
};
